export default {
    methods: {
        goToURL (url) {
            this.$router.go(url);
        },
        newWindow(url) {
            window.open(url)
        }
    }
}